<template>
  <li
    class="preview-sidebar-item"
    :class="{ 'preview-sidebar-item--active': active }"
  >
    <RouterLink
      :to="item.link"
      class="preview-sidebar-item__link"
    >
      <div class="preview-sidebar-item__icon">
        <RriIcon
          :icon="item.icon"
          size="md"
        />
        <BadgeNumeric
          :value="item.badge"
          size="sm"
        />
      </div>
      <span class="preview-sidebar-item__label">
        {{ item.label }}
      </span>
    </RouterLink>
  </li>
</template>

<script>
import RriIcon from '@/components/rri/RriIcon.vue'
import BadgeNumeric from '@/components/common/BadgeNumeric.vue'

export default {
  name: 'AppSidebarItem',
  components: { RriIcon, BadgeNumeric },
  props: {
    item: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.preview-sidebar-item {
  list-style: none;
  width: 100%;

  // Static colours: the sidebar is always blue, independent of the theme.
  &--active .preview-sidebar-item__link {
    background-color: var(--color-static-blue-600);
    border-color: rgba(0, 0, 0, 0.15);
  }

  &__link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--space-2);
    width: 100%;
    padding: var(--space-8) var(--space-2);
    border-radius: var(--border-radius-16);
    text-decoration: none;
    border: 1px solid transparent;
    cursor: pointer;
    transition: background-color 0.15s ease;
    min-width: 0;
  }

  &:not(&--active) .preview-sidebar-item__link:hover {
    background-color: rgba(0, 0, 0, 0.08);
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--space-24);
    height: var(--space-24);
    --fill-0: var(--color-static-blue-50);
    position: relative;

    :deep(.badge-numeric) {
      position: absolute;
      top: -6px;
      right: -10px;
      color: var(--color-white);
    }
  }

  &__label {
    font-size: 10px;
    font-weight: var(--weight-medium);
    line-height: var(--leading-170);
    color: var(--color-static-blue-50);
    white-space: nowrap;
    text-align: center;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
